import { px2rem } from '../utils/helpers/style.js';
/**
 * This is an auto generated file - do not modify manually!
 * Fonts are fetched via Figma api
 */

var fontSizes = {
  xl: {
    "default": px2rem(20),
    s: px2rem(23)
  },
  l: {
    "default": px2rem(18),
    s: px2rem(20)
  },
  m: {
    "default": px2rem(16),
    s: px2rem(18)
  },
  s: {
    "default": px2rem(14),
    s: px2rem(16)
  },
  xs: {
    "default": px2rem(12),
    s: px2rem(14)
  }
};
export { fontSizes };